import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6b49160e")
const _hoisted_1 = { id: "bottom-tool-bar-component" }
const _hoisted_2 = { id: "button-container" }
const _hoisted_3 = { id: "left-buttons" }
const _hoisted_4 = { id: "background" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "button-name" }, "Background", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  "aria-label": "Place holder caret",
  class: "right-side"
}, [
  /*#__PURE__*/_createElementVNode("b", { class: "caret" })
], -1)
const _hoisted_7 = { id: "orientation" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "button-name" }, "Orientation", -1)
const _hoisted_9 = { class: "left-side-right-btn" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", { class: "caret" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { id: "ranges-wrap" }
const _hoisted_13 = {
  ref: "onBoardingZoomSliderRef",
  id: "zoom-inputs"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "button-name" }, "Zoom", -1)
const _hoisted_15 = { id: "label-wrap" }
const _hoisted_16 = { class: "labels" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "labels" }
const _hoisted_19 = ["value"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToggleColorPickr && _ctx.handleToggleColorPickr(...args))),
            class: "left-side-right-btn"
          }, [
            _createElementVNode("button", {
              "aria-label": "Open Color Picker",
              style: _normalizeStyle({
                background:
                  _ctx.currentLabelBgColor && _ctx.currentLabelBgColor.length ? _ctx.currentLabelBgColor : '#fff',
              }),
              class: "left-side",
              id: "canvas-bg-color"
            }, null, 4),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              "aria-label": "Open and close orientation selector",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openOrientationSelect())),
              class: "left-side"
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "tool-icon",
                icon: "file",
                rotation: _ctx.displayOrientation === 'Landscape' ? '90' : null,
                "aria-hidden": "true"
              }, null, 8, ["rotation"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.displayOrientation), 1)
            ]),
            _createVNode(_Transition, {
              name: "expand",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_ctx.openOrientation)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.choseOrientation(_ctx.alternateOrientation))),
                      class: "middle expanded"
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "tool-icon",
                        icon: "file",
                        rotation: _ctx.alternateOrientation === 'Landscape' ? '90' : null,
                        "aria-hidden": "true"
                      }, null, 8, ["rotation"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.alternateOrientation), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              "aria-label": "Choose opposite orientation",
              class: "right-side",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.choseOrientation(_ctx.alternateOrientation)))
            }, _hoisted_11)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, [
              _createElementVNode("input", {
                type: "range",
                min: "1",
                max: "500",
                value: _ctx.zoomValue,
                class: "slider",
                ref: "zoomSlider",
                onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleZoom && _ctx.handleZoom(...args))),
                onMousedown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDownZoom && _ctx.handleMouseDownZoom(...args))),
                onMouseup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleMouseUpZoom && _ctx.handleMouseUpZoom(...args)))
              }, null, 40, _hoisted_17)
            ]),
            _createElementVNode("label", _hoisted_18, [
              _createElementVNode("input", {
                type: "text",
                value: _ctx.zoomValue,
                onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleZoom && _ctx.handleZoom(...args)))
              }, null, 40, _hoisted_19)
            ])
          ])
        ], 512)
      ])
    ])
  ]))
}